import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Backdrop from "../../components/backdrop/Backdrop";
import { subscribeThunk } from "../../redux/user/thunks";
import { useSelector, useDispatch } from "react-redux";
import { getAccountThunk } from '../../redux/user/thunks';
import Toast from "../../components/toast/Toast";
import { hideToast } from "../../redux/user/userSlice";
import moment from "moment";

export default function Activity() {
  let userData = useSelector((state) => state.user.data);
  const error = useSelector(state => state.user.error);
  const errorMessage = useSelector(state => state.user.eData?.message);
  let loading = useSelector((state) => state.user.loading);
  let subscribeLink = useSelector(state => state.user.subscribeLink);
  let mpSubscription = useSelector(state => state.user.mpSubscription);
  const dispatch = useDispatch();
  const [loadingAval, setLoadingAval] = useState(false);
  const [showWireDetails, setShowWireDetails] = useState(false);

  console.log(errorMessage)


  const handleToast = () => {
    dispatch(hideToast())
}

  const onSubscribe = (member) => {
    dispatch(subscribeThunk({ aval1: "-", aval2: "-" }));
  };

  const onSubscriptionContinue = () => {
    window.location.replace(userData.subscription.link)
  }

  useEffect(() => {
    dispatch(getAccountThunk())
}, [])

useEffect(() => {
  if (subscribeLink) {
      setLoadingAval(true)
      window.location.replace(subscribeLink)
  }
}, [subscribeLink])


  if (loading || loadingAval) {
    return <Backdrop show={true} />;
  }

  if (userData.membershipStatus === 'authorized' ) {
    const isCredit = userData.subscription?.type === 'credit';
    const mpLink = mpSubscription?.link || userData.subscription?.link;
    const lastCharged = mpSubscription?.lastCharged || userData.subscription?.lastCharged;
    const chargedAmount = mpSubscription?.chargedAmount || userData.subscription?.chargedAmount;
    const nextPaymentDate = mpSubscription?.nextPaymentDate;
    const dueDate = userData.subscription?.dueDate;

    return (
      <div className="container" style={{marginTop: '10vh'}}>
         <div
            className={"title-bold-blue text-center"}
            style={{
              fontSize: "3rem",
              lineHeight: "3rem",
              paddingTop: "2rem",
              paddingBottom: "2rem",
            }}
          >
            <p>Su subscripción se encuentra actualmente activa.</p>
          </div>
          <div className="columns is-justify-content-center">
            <div className="column is-8" style={{ fontSize: "1rem" }}>
              <p>Forma de pago: {isCredit ? "Mercado Pago" : "Transferencia bancaria"}</p>
              {lastCharged ? (
                <p>Último pago: {moment(lastCharged).format('DD/MM/YYYY')}{chargedAmount ? ` - $${chargedAmount}` : ''}</p>
              ) : null}
              {isCredit && nextPaymentDate ? (
                <p>Próximo intento de cobro: {moment(nextPaymentDate).format('DD/MM/YYYY')}</p>
              ) : null}
              {!isCredit && dueDate ? (
                <p>Vencimiento: {moment(dueDate).format('DD/MM/YYYY')}</p>
              ) : null}
              {isCredit && mpLink ? (
                <a
                  href={mpLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "white", fontSize: "16px" }}
                  className="button bg-blue"
                >
                  Gestionar en Mercado Pago
                </a>
              ) : null}
            </div>
          </div>
      </div>
    )
  }

  return (
    <div className="container" style={{marginTop: '10vh'}}>
      <div className="columns is-justify-content-center">
        <div className="column is-8">
          <div
            className={"title-bold-blue text-center"}
            style={{
              fontSize: "3rem",
              lineHeight: "3rem",
              paddingTop: "2rem",
              paddingBottom: "2rem",
            }}
          >
            <p>Pagar membresía</p>
          </div>
          <div
            style={{ fontSize: "1rem", paddingBottom: "1rem" }}
          >
            <p>
              Estimado/a recuerde que la cuota actual es de 50.000 y se paga de
              forma anual. La suscripción incluye acceso a todo el contenido de
              AAOC TV y a eventos exclusivos.
            </p>
          </div>
          <div
            className="buttons is-justify-content-center"
            style={{ display: "flex", gap: "1rem", paddingTop: "1rem" }}
          >
            <button
              onClick={
                 onSubscribe
              }
              style={{ color: "white", fontSize: "16px" }}
              className="button bg-blue"
            >
              Mercado Pago
            </button>
            <button
              onClick={setShowWireDetails}
              style={{ color: "white", fontSize: "16px" }}
              className="button bg-blue"
            >
              Transferencia Bancaria
            </button>
          </div>
        </div>
      </div>
      <div
        className="columns is-justify-content-center"
        style={{ display: showWireDetails ? "flex" : "none" }}
      >
        <div className="column is-8">
          <div
            className={"title-bold-blue text-center"}
            style={{
              fontSize: "2rem",
              lineHeight: "3.4rem",
              paddingTop: "2rem",
            }}
          >
            <p>Datos de transferencia</p>
          </div>
          <div
            style={{ fontSize: "1rem" }}
          >
            <p
              style={{
                fontSize: "1rem",
                lineHeight: "1rem",
              }}
            >
              Por favor al realizar la transferencia enviar el comprobante junto
              con su nombre y apellido a consultasaaoc@gmail.com. Será
              notificado por mail una vez que haya sido dado de alta. 
              El costo de la cuota es de $50.000
            </p>
            <p>
              <br />
              Titular: ASOCIACION ARGENTINA DE ONCOLOGIA CLINICA
              <br />
              CUIT: 30650422496
              <br />
              Banco: Banco Galicia
              <br />
              Cuenta Corriente en Pesos N°: 00011144-5 128-5
              <br />
              CBU: 0070128620000011144559
              <br />
            </p>
          </div>
        </div>
      </div>

      <Toast visible={error ? true : false} handleToast={handleToast} message={errorMessage} title={"Error"} />
    </div>
  );
}
